import { render } from "./bannerBottom.vue?vue&type=template&id=235d6df9&scoped=true"
import script from "./bannerBottom.vue?vue&type=script&lang=js"
export * from "./bannerBottom.vue?vue&type=script&lang=js"

import "./bannerBottom.vue?vue&type=style&index=0&id=235d6df9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235d6df9"]])

export default __exports__